import { useMemo } from 'react'

import { defaultLocale } from './language'
import { type PageType, type Slugs, getPageUrl } from './routes'

/**
 * Default locale page canonical URL hook.
 */
export const useDefaultLocaleCanonicalUrl = (
  pageType: PageType,
  slug?: Slugs
) => {
  return useMemo(() => {
    if (typeof window === 'undefined') {
      return
    }

    const origin = window.location.origin
    const canonicalPageUrl = getPageUrl(defaultLocale, pageType, slug)

    return `${origin}${canonicalPageUrl}`
  }, [pageType, slug])
}
